import React, { useEffect, useRef, useState } from 'react';
import CopyLinkIconButton from '../CopyLinkIconButton/CopyLinkIconButton';

interface CopyTextIconButtonProps {
  value: string | null | undefined;
  ariaLabel: string;
}

const CopyTextIconButton: React.FC<CopyTextIconButtonProps> = ({ value, ariaLabel }) => {
  const [copied, setCopied] = useState(false);
  const timerRef = useRef<number | null>(null);
  const copyValue = value ?? '';

  useEffect(() => () => {
    if (timerRef.current !== null) {
      window.clearTimeout(timerRef.current);
    }
  }, []);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(copyValue);
      setCopied(true);
      if (timerRef.current !== null) {
        window.clearTimeout(timerRef.current);
      }
      timerRef.current = window.setTimeout(() => {
        setCopied(false);
        timerRef.current = null;
      }, 5000);
    } catch {
      alert(`Não foi possível ${ariaLabel.toLowerCase()}.`);
    }
  };

  return (
    <CopyLinkIconButton
      state={copied ? 'success' : 'idle'}
      ariaLabel={ariaLabel}
      onClick={handleCopy}
      disabled={!copyValue.trim()}
    />
  );
};

export default CopyTextIconButton;
